import { useCallback } from "react";

import BaseSearchButton from "NavBar/components/FloatingButtonPanel/SearchButton";
import { navSectionKeys } from "NavBar/navBarStore";

import { navAccentColors } from "UI/colors";

import { useSearchValue } from "../Groups/groupsCommunicationStore";

import { useIsActive } from "./floatingSearchStore";
import {
  activeBackgroundColor,
  inactiveBackgroundColor,
} from "./styleConstants";

const PLACEHOLDER = "Search all groups...";
const DATA_CY_INPUT = "NavBar_FloatingSearchInput";
const DATA_CY_CLOSE_BUTTON = "GroupCommunication_FloatingSearch_CloseButton";
const DATA_CY_SEARCH_BUTTON = "NavBar_FloatingSearchButton";

const SearchButton = () => {
  const [searchValue, setSearchValue] = useSearchValue();
  const [isActive, setIsActive] = useIsActive();

  const clearSearch = useCallback(() => {
    setSearchValue("");
  }, [setSearchValue]);

  return (
    <BaseSearchButton
      isActive={isActive}
      setIsActive={setIsActive}
      searchValue={searchValue}
      onSearchChange={setSearchValue}
      onClearSearch={clearSearch}
      placeholder={PLACEHOLDER}
      dataCyInput={DATA_CY_INPUT}
      dataCyCloseButton={DATA_CY_CLOSE_BUTTON}
      dataCySearchButton={DATA_CY_SEARCH_BUTTON}
      inactiveBackgroundColor={inactiveBackgroundColor}
      activeBackgroundColor={activeBackgroundColor}
      glowColor={navAccentColors[navSectionKeys.groups][0]}
    />
  );
};

export default SearchButton;
